import { Command } from 'commander';
import { ApiClient } from '../client.js';
import { formatOutput } from '../output.js';
import { parseData, getDatabase, getFormat } from '../helpers.js';
import { confirm } from '../prompt.js';

export const collectionsCommand = new Command('collections')
  .description('Manage collections');

collectionsCommand.command('list')
  .description('List all collections in a database')
  .action(async function (this: Command) {
    const ws = getDatabase(this);
    const client = new ApiClient();
    const data = await client.request('GET', `/v1/${ws}/collections`);
    console.log(formatOutput(data, getFormat(this)));
  });

collectionsCommand.command('get <id>')
  .description('Get a collection')
  .action(async function (this: Command, id: string) {
    const ws = getDatabase(this);
    const client = new ApiClient();
    const data = await client.request('GET', `/v1/${ws}/collections/${id}`);
    console.log(formatOutput(data, getFormat(this)));
  });

collectionsCommand.command('upsert <id>')
  .description('Create or update a collection')
  .requiredOption('--name <name>', 'Collection name')
  .option('--description <desc>', 'Description')
  .option('--schema <json>', 'JSON Schema (inline JSON or @filename)')
  .option('--icon <icon>', 'Icon name')
  .option('--color <color>', 'Hex color')
  .option('--sources <json>', 'External sources config (inline JSON or @filename)')
  .action(async function (this: Command, id: string, opts: { name: string; description?: string; schema?: string; icon?: string; color?: string; sources?: string }) {
    const ws = getDatabase(this);
    const client = new ApiClient();
    const body: Record<string, unknown> = { name: opts.name };
    if (opts.description) body['description'] = opts.description;
    if (opts.schema) body['json_schema'] = parseData(opts.schema);
    if (opts.icon) body['icon'] = opts.icon;
    if (opts.color) body['color'] = opts.color;
    if (opts.sources) body['sources'] = parseData(opts.sources);
    const data = await client.request('PUT', `/v1/${ws}/collections/${id}`, body);
    console.log(formatOutput(data, getFormat(this)));
  });

collectionsCommand.command('delete <id>')
  .description('Delete a collection')
  .option('-y, --yes', 'Skip confirmation prompt')
  .action(async function (this: Command, id: string, opts: { yes?: boolean }) {
    if (!opts.yes && !(await confirm(`Delete collection "${id}"? This cannot be undone.`))) {
      console.log('Aborted');
      return;
    }
    const ws = getDatabase(this);
    const client = new ApiClient();
    await client.request('DELETE', `/v1/${ws}/collections/${id}`);
    console.log('Deleted');
  });

collectionsCommand.command('history <id>')
  .description('View the change history (audit log) for a collection — every schema/config version, who changed it, and when')
  .option('--limit <n>', 'Max results')
  .option('--offset <n>', 'Pagination offset')
  .option('--diff', 'Include field-level diffs between versions')
  .action(async function (this: Command, id: string, opts: { limit?: string; offset?: string; diff?: boolean }) {
    const ws = getDatabase(this);
    const client = new ApiClient();
    const qs = new URLSearchParams();
    if (opts.limit) qs.set('limit', opts.limit);
    if (opts.offset) qs.set('offset', opts.offset);
    if (opts.diff) qs.set('diff', 'true');
    const q = qs.toString();
    const data = await client.request('GET', `/v1/${ws}/audit/collections/${id}${q ? `?${q}` : ''}`);
    console.log(formatOutput(data, getFormat(this)));
  });
